import React from "react";
import "./Center.scss";

export default function Center(props) {
  return <div className="center">{props.children}</div>;
};
